import React from 'react';
import { Switch } from 'react-router-dom';

import ErrorBoundaryRoute from 'app/shared/error/error-boundary-route';

import KpiData from './kpi-data';
import KpiDataDetail from './kpi-data-detail';
import KpiDataUpdate from './kpi-data-update';
import KpiDataDeleteDialog from './kpi-data-delete-dialog';

const Routes = ({ match }) => (
  <>
    <Switch>
      <ErrorBoundaryRoute exact path={`${match.url}/new`} component={KpiDataUpdate} />
      <ErrorBoundaryRoute exact path={`${match.url}/:id/edit`} component={KpiDataUpdate} />
      <ErrorBoundaryRoute exact path={`${match.url}/:id`} component={KpiDataDetail} />
      <ErrorBoundaryRoute path={match.url} component={KpiData} />
    </Switch>
    <ErrorBoundaryRoute exact path={`${match.url}/:id/delete`} component={KpiDataDeleteDialog} />
  </>
);

export default Routes;
